import axios from 'axios'
import axiosRetry from 'axios-retry'

export const msgHTTP = axios.create({
  baseURL: import.meta.env.VITE_MESSAGING_API_URL,
  timeout: 15000,
  timeoutErrorMessage: 'Request timed out',
  adapter: 'fetch'
})

msgHTTP.interceptors.request.use(async req => {
  const token = await window.Clerk?.session?.getToken()
  if (token) {
    req.headers.Authorization = `Bearer ${token}`
  }
  return req
})

msgHTTP.interceptors.response.use(
  res => res.data?.data ?? res.data,
  error => {
    console.error('Error in messaging http', error?.response?.request?.url, error?.response.data)
    return Promise.reject(error?.response?.data)
  }
)

axiosRetry(msgHTTP, {
  shouldResetTimeout: true,
  onRetry: async (_, error) => {
    console.warn('Retry msgHTTP API', error.config?.url)
  }
})
